import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { KEYWORD_SEARCH_MAX_KEYWORDS, KEYWORD_SEARCH_MAX_LENGTH, LoggingService } from "src/app/core";
import { VisionboardCategoriesService } from "../../../services";
import { VisionboardGlobalItemSearchService } from "../../services";

const Workflow = "VBGlobalSearch";
const WorkflowSource = "GlobalSearchSearchInput";

@Component({
    selector: "app-visionboard-global-search-search-input",
    templateUrl: "./visionboard-global-search-search-input.component.html",
    styleUrls: ["./visionboard-global-search-search-input.component.scss"],
    standalone: false
})
export class VisionboardGlobalSearchSearchInputComponent implements OnInit, OnDestroy {
  @Input() searchTerm: string;
  @Input() subCategories: string[];
  @Output() keywordSearch: EventEmitter<string> = new EventEmitter<string>();

  readonly maxLength = KEYWORD_SEARCH_MAX_LENGTH;
  readonly maxKeywords = KEYWORD_SEARCH_MAX_KEYWORDS;

  constructor(
    private _visionboardGlobalItemSearchService: VisionboardGlobalItemSearchService,
    private _visionboardCategoriesService: VisionboardCategoriesService,
    private _loggingService: LoggingService,
  ) {}

  ngOnInit(): void {
    let subCategoryIds: number[];

    if (this.subCategories) {
      subCategoryIds = this._visionboardCategoriesService
        .getCurrentSubcategories()
        .filter(sc => this.subCategories.includes(sc.name))
        .map(sc => sc.subCategoryId);
    } else {
      subCategoryIds = this._visionboardCategoriesService.getCurrentSubcategories().map(sc => sc.subCategoryId);
    }

    this._visionboardGlobalItemSearchService.setSubCategoryIds(subCategoryIds);
  }

  ngOnDestroy(): void {
    this._visionboardGlobalItemSearchService.setSubCategoryIds([]);
  }

  onSearch(searchTerm: string): void {
    this._loggingService.logWorkflow(
      "Global search search input search",
      "VisionboardGlobalSearchSearchInputComponent.onSearch",
      Workflow,
      "GlobalInputSearch",
      WorkflowSource,
      {
        SearchTerm: searchTerm,
      },
    );

    this.keywordSearch.emit(searchTerm);
  }
}
